export function toNumber(value: string | null | undefined): number | undefined {
  if (value == null || value.trim() === '') {
    return undefined;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}
